<!-- 
  Provides a password input field with optional masking

  PROPS:
    label: String label, e.g. "Password"

    password: Initial password value

    rules: Optional array of Vuetify validation rules

    maxlength: Optional maxlength

    hint: Optional hint text string

    validateOnBlur: Optional pass through of validate-on-blur

  EVENTS:
    @change(password) - Fires when a password is entered or cleared.
-->

<template>
  <v-text-field
    :type="isMasked ? 'password' : 'text'"
    class="ads-password"
    v-model.trim="inputValue"
    :rules="rules"
    :label="label"
    :hint="hint"
    :error="false"
    placeholder=" "
    outlined
    :maxlength="maxlength"
    ref="input"
    @keyup="onChange"
    :validate-on-blur="validateOnBlur"
  >
    <template slot="append">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon class="ads-navy" @click="toggleMask" v-on="on">{{
            isMasked ? 'mdi-eye' : 'mdi-eye-off'
          }}</v-icon>
        </template>
        <span>{{
          isMasked ? 'Click to see value' : 'Click to hide value'
        }}</span>
      </v-tooltip>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'Password',

  props: {
    password: String,
    label: {
      default() {
        return 'Password'
      },
      type: String
    },
    rules: Array,
    maxlength: Number,
    hint: String,
    validateOnBlur: {
      default() {
        return true
      },
      type: Boolean
    }
  },

  data() {
    return {
      inputValue: null,
      isMasked: true
    }
  },

  mounted() {
    this.inputValue = this.password
  },

  watch: {
    password() {
      if (this.inputValue !== this.password) {
        this.inputValue = this.password
      }
    }
  },

  methods: {
    toggleMask() {
      this.isMasked = !this.isMasked
    },
    onChange() {
      if (this.inputValue !== this.password) {
        this.$emit('change', this.inputValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
